
import { ModalProps } from '../models';
import { useEffect, useState } from 'react';
import {ReactComponent as DeleteIcon} from '../../../images/nde-icon-delete.svg';
import './ShareModal.scss';
import ReactModal from 'react-modal';
import { useSelector } from 'react-redux';
import { selectControls } from '../../../redux/controls';
import { selectIdsForDownload } from '../../../redux/queryResults';
import { 
  tabToShareTop, openFacebookShare, 
  openShareEmail, openTwitterShare, getUrl, openPublishPanel, 
  openDownloadPanel, openSeeHowStudentsPerformedPanel, getShareInfo, SHARE_INFO_REQUEST_RESPONSE
} from '../../ShareLink/models/ShareLink.utils';
import Spinner from '../../Spinner/Spinner';
import { ERROR_RESPONSE, ErrorResponse, isType } from '../../../shared';
import SocialEmail from '../../../images/social_media_email.png';
import SocialTw from '../../../images/x_twitter.png';
import SocialFb from '../../../images/social_media_fb.png';
import SocialLink from '../../../images/social_media_link.png';
import gaEvents from '../../../shared/analyticsEvents';

import { selectShareEmail, selectShareFacebookUrl, selectShareTwitterUrl } from '../../../redux/appSettings';
import { ShareInfoRequest, ShareInfoRequestResponse } from '../../ShareLink/models/ShareLink.interfaces';


export const ShareModal = ({open, onClose}: ModalProps): JSX.Element => {
  const controls = useSelector(selectControls);
  const shareFacebookUrl = useSelector(selectShareFacebookUrl);
  const [isDownloading, setIsDownloading] = useState<boolean>(false);
  const shareEmailUrl = useSelector(selectShareEmail);
  const [infoResponse, setInfoResponse] = useState<ShareInfoRequestResponse | null>(null);
  const [showLinkTextbox, setshowLinkTextbox] = useState<boolean>(false);
  const [showLinkError, setshowLinkError] = useState<boolean>(false);
  const [isModalOpen, setModalIsOpen] = useState<boolean>(open);
  
 
  const shareTwitterUrl = useSelector(selectShareTwitterUrl);
  const resetIsDownloading = () => { setIsDownloading(false); };
  const idsForDownload = useSelector(selectIdsForDownload);
  

  const toggleShowTextBox = () => { 
    gaEvents.onGA4ShareLink('URL');
    const bookmarkArray = [];

    if(idsForDownload){
      const sizeObject = Object.keys(idsForDownload).forEach(key => {
        bookmarkArray.push(key);
      });
      
      console.log('TCL: toggleShowTextBox -> sizeObject', sizeObject);
      const bookmarkLength = bookmarkArray.length;
      if(bookmarkLength < 150){
        setshowLinkError(false);
        setshowLinkTextbox(!showLinkTextbox); 
      } else {
        setshowLinkError(true); 
        setshowLinkTextbox(!showLinkTextbox); 
      }
    }
  };

  const goToCreatePublishTest = () => {
    onClose(false);
    openPublishPanel();
  };

  const goToDownloadTest = () => {
    onClose(false);
    openDownloadPanel();
  };

  const goToSeeHowStudentsPerformed = () => {
    onClose(false);
    openSeeHowStudentsPerformedPanel();
  };

  // when a modal is open, prevent background scrolling
  useEffect(() => {
    setModalIsOpen(open);
    if(isModalOpen === true){
      document.body.classList.add('bg-noscroll');
    } else {
      if(document.body.classList.contains('bg-noscroll')){
        window.scrollTo(0,0);
        document.body.classList.remove('bg-noscroll');
      }
    }
  },[open, isModalOpen]);



  useEffect(() => {
    const abortController = new AbortController();
    try {
      if (!!idsForDownload && Object.keys(idsForDownload).length > 0) {
        const ids = Object.keys(idsForDownload).map((keyString) => parseInt(keyString, 10));
        const shareInfoRequest: ShareInfoRequest = {
          itemList: ids,
          currentAppHomeUrl: getUrl()
        };
        setIsDownloading(true);
        const shareInfo = getShareInfo(shareInfoRequest, abortController);
        shareInfo.then((response) => {
          if (isType<ShareInfoRequestResponse>(response, SHARE_INFO_REQUEST_RESPONSE)) {
            setInfoResponse(response);
          } else if (isType<ErrorResponse>(response, ERROR_RESPONSE)) {
            console.error('error', response);
          }
          const facebookButton = document.getElementById('nqt-shl--facebook') as HTMLElement;
          if (facebookButton) {
            facebookButton.focus();
          }
        }).catch((error) => { console.log('error', error); })
          .finally(resetIsDownloading);
      }
    } catch (error) {
      console.log('error', error);
    }

    return () => { resetIsDownloading(); };
  },
  // eslint-disable-next-line
    [idsForDownload]);


  useEffect(() => {
    if (showLinkTextbox) {
      const linkTextbox = document.getElementById('shareLinkTextboxInput') as HTMLInputElement;
      if (linkTextbox) {
        linkTextbox.select();
        linkTextbox.focus();
      }
    } 
  }, [showLinkTextbox]);


  return (
    <>
      {
        open &&
        <ReactModal
          isOpen={open}
          className="nqt-modal nqt-share-modal"
          overlayClassName="nqt-modal-overlay"
          shouldFocusAfterRender={true}
          shouldReturnFocusAfterClose={true}
          contentLabel={controls?.ShareTitleText?.controlText}
        >
          <div className='nqt-modal--container'>
            <div className="nqt-modal--header-group">
              <header className='nqt-modal--title'>{controls?.HideShare?.controlText}</header>
              <button className='nqt-modal--close-button'
                ref={(el) => el?.focus()}
                onClick={() => {onClose(false); setshowLinkTextbox(false); }}>
                <DeleteIcon/>
                <span className="visually-hidden">{controls?.ModalClose?.controlText}</span>
              </button>
            </div>
            <div className="nqt-modal--border">
              <section id='shareLinkPopper' className="nqt-modal--content">
                {isDownloading && <Spinner size={100} />}
                <div className='container'>
                  <div className='row'>
                    <div className="row pt-2">
                      <div className="">
                        <button id="nqt-shl--online-test" onClick={goToCreatePublishTest} {...(!infoResponse?.testTableItemsExist) && { disabled: false }}>
                          {controls?.ShareOnlineTestLink?.controlText}</button>
                      </div>
                    </div>
                    <div className='row nqt-shl-text'>
                      <div className="">
                        <span className='nqt-shl-text'>{controls?.ShareOnlineTextExplainer?.controlText}</span>
                      </div>
                    </div>
                    <div className="row pt-1">
                      <div className="">
                        <hr className="" />
                      </div>
                    </div>
                    <div className='row pt-2'>
                      <div className="">
                        <button id="nqt-shl--students-performed" className='nqt-shl-download-link'
                          key='hasNoTests'
                          onClick={goToSeeHowStudentsPerformed}
                        >{controls?.SharePerformLink?.controlText}
                        </button>
                      </div>
                    </div>
                    <div className='row nqt-shl-text'>
                      <div>
                        <span className='nqt-shl-text'>{controls?.SharePerformTextExplainer?.controlText}</span>
                      </div>
                    </div>
                    <div className="row pt-1">
                      <div>
                        <hr className="" />
                      </div>
                    </div>
                    <div className="row pt-2">
                      <div>
                        <button id="nqt-shl--download" className='nqt-shl-download-link'
                          key='hasNoTests'
                          onKeyDown={tabToShareTop(!infoResponse?.testTableItemsExist)}
                          onClick={goToDownloadTest}
                        >{controls?.ShareDownloadLink?.controlText}
                        </button>
                      </div>
                    </div>
                    <div className='row nqt-shl-text'>
                      <div>
                        <span className='nqt-shl-text'>{controls?.ShareDownloadTextExplainer?.controlText}</span>
                      </div>
                    </div>
                    <div className="row pt-1">
                      <div>
                        <hr className="" />
                      </div>
                    </div>
                    <div className="row pt-1">
                      <div className="nqt-shl-title">
                        {controls?.ShareTitleText?.controlText}
                      </div>
                    </div>
                    <div className="share-container">
                      <div className="nqt-shl-social-button">
                        <button className='nqt-shl-inline-f' id="nqt-shl--facebook" onClick={openFacebookShare(shareFacebookUrl, infoResponse ? infoResponse.sharingURL : '')}>
                          <img alt="share on Facebook" src={SocialFb}></img>{controls?.ShareFacebook?.controlText}
                        </button>
                      </div>
                      <div className="nqt-shl-social-button">
                        <button className='nqt-shl-inline-f' id="nqt-shl--email" onClick={openShareEmail(shareEmailUrl, infoResponse ? infoResponse.sharingURL : '')}>
                          <img alt="send email" src={SocialEmail} ></img>{controls?.ShareEmail?.controlText}
                        </button>
                      </div>
                      <div className="nqt-shl-social-button">
                        <button className='nqt-shl-inline-f' id="nqt-shl--twitter" onClick={openTwitterShare(shareTwitterUrl, infoResponse ? infoResponse.sharingURL : '')}>
                          <img alt="share on Twitter" src={SocialTw}></img>{controls?.ShareX?.controlText}
                        </button>
                      </div>
                      <div className="nqt-shl-social-button">
                        <button className='nqt-shl-inline-f' id="nqt-shl--link" onClick={toggleShowTextBox}>
                          <img alt="create web link" src={SocialLink} ></img>{controls?.ShareLink?.controlText}
                        </button>
                      </div>
                      <div id='nqt-shl--link-area' className={(showLinkTextbox ? 'showLinkTextbox' : '')}>
                        <label htmlFor="shareLinkTextboxInput">{controls?.ShareLink?.controlText}</label>
                        <div id='nqt-shl--link-error' className={(showLinkError ? 'showLinkError' : '')}>{controls?.ShareBookmarkLengthTooLong?.controlText}</div>
                        <input id='shareLinkTextboxInput' 
                          aria-labelledby="shareLinkTextboxInput"
                          onChange={(evt) => { evt.preventDefault(); }}
                          value={showLinkError == true ? '' : infoResponse?.sharingURL || ''}
                          className="shareLinkTextbox"
                          type="text" />
                      </div>
                      
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </ReactModal>
      }
    </>
  );
};

export default ShareModal;